// extracted by mini-css-extract-plugin
export var active = "search-module--active--n1Gkc";
export var catButton = "search-module--catButton--pOpxI";
export var hero = "search-module--hero--4+ea0";
export var label = "search-module--label--USYJo";
export var noResult = "search-module--noResult--V6l-I";
export var products = "search-module--products--DTrIz";
export var searchWord = "search-module--searchWord--KfOHJ";
export var wrapper = "search-module--wrapper--9TGjX";